<template lang="pug">
  div
    .error-continter
      .error-block
        img.error-img(:src="getImgStatus")
        .tip {{getTipStatus}}
      .container
        .reload-btn(@click="handleClickEvent" v-if="getBtnStatus") {{getBtnStatus}}
        //- .subtip(v-if="showSubTip") {{'距离骑行1分卡优惠仅剩一步\n更新版本后，再次打开哈啰App可直接进入活动页'}}
</template>

<script>
import { Navigator } from '@hb/h5-navigator';
import { getTokenAndKey } from '@/utils';
import { getEnv, getSystemCode } from '@/utils/systemCode';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { JUMP_URL_SOURCES } from '../passwordFreePay/const';
import { ParamsUtil } from '../../utils/params';
import { copyHaCodeAndJumpToAppMarket } from './common/helper';
import {
  CARD_TYPE,
  NET_IMG,
  SIGN_IMG,
  LOW_VERSION_IMG,
  FAIL_CODE,
  LOW_VERSION_CODE,
} from './common/const';


export default {
  props: {
    signIn: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
    msg: {
      type: String,
      default: '',
    },
    getDataState: {
      type: Boolean,
      default: false,
    },
    code: {
      type: Number,
      default: null,
    },
    haCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDouyinMP: getEnv().isDouyinMP, // 是否是抖音小程序环境
    };
  },
  computed: {
    showSubTip() {
      return this.isLogin && this.lowVersion && !this.isDouyinMP;
    },
    getImgStatus() {
      if (this.emptyType === 1 && !this.isDouyinMP) {
        return LOW_VERSION_IMG;
      }
      if (this.emptyType === 3) {
        return NET_IMG;
      }

      return SIGN_IMG;
    },
    getTipStatus() {
      if (!this.isLogin) return '抱歉，你不能参与当前活动，登录后再试试';
      if (this.emptyType === 3) return '网络开小差啦！请稍后再试';
      return `${this.msg || '抱歉，您不符合活动参与条件'}`;
    },
    getBtnStatus() {
      // eslint-disable-next-line no-console
      console.log('lowVersion', this.lowVersion);
      if (this.isDouyinMP) return ''; // 抖音小程序不显示按钮
      if (!this.isLogin) return '去登录';
      if (this.lowVersion) return '去更新';
      if (this.code === FAIL_CODE) return '刷新试试';
      return '返回';
    },
    emptyType() {
      // 版本过低
      if (this.code === LOW_VERSION_CODE) {
        return 1;
      }
      // 网络问题
      if (this.code === FAIL_CODE) {
        return 3;
      }
      // 不符合参与条件
      return 2;
    },
    lowVersion() {
      return this.code === LOW_VERSION_CODE;
    },
  },
  async created() {
    // this.lowVersion = await getVersion() < '6.90.0';
    const { cardType = CARD_TYPE.BIKE, adsource } = ParamsUtil.getParams(window.location.href);
    UBT.pageView({
      pageId: 'platform_tt_card_empty',
      categoryId: 'platform',
      businessInfo: {
        type: this.emptyType,
        cardtype: cardType,
        adsource,
        systemcode: getSystemCode(),
      },
    });
  },
  methods: {
    async handleClickEvent() {
      UBT.clickButton({
        pageId: 'platform_tt_card_empty',
        buttonName: 'platform_tt_card_empty_buttun',
        categoryId: 'platform',
        businessInfo: {
          buttunName: this.getBtnStatus,
          systemcode: getSystemCode(),
        },
      });
      //  版本低，复制ha口令并跳转到应用市场
      if (this.lowVersion) {
        copyHaCodeAndJumpToAppMarket(this.haCode);
        return;
      }
      if (!this.isLogin) {
        getTokenAndKey({ force: true });
        return;
      }
      if (this.code === FAIL_CODE) {
        this.$emit('refresh');
      } else {
        Navigator.go(JUMP_URL_SOURCES.bikeHome);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.error-continter {
  height: 100vh;
  background: #fff;

  .error-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;

    img.error-img {
      width: 1.91rem;
      height: 1.5rem;
      object-fit: contain;
    }

    .tip {
      font-size: 0.14rem;
      margin-top: 0.1rem;
      color: #5a6066;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      width: 2.5rem;
      text-align: center;
    }
  }

  .reload-btn {
    font-size: 0.14rem;
    background: #08f;
    color: #fff;
    min-width: 0.96rem;
    height: 0.34rem;
    border-radius: 16px;
    text-align: center;
    line-height: 0.34rem;
    margin: 0.2rem auto;
    padding: 0 0.2rem;
    display: inline-block;
  }

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .subtip {
    font-size: 0.12rem;
    margin-top: 0.1rem;
    color: #5a6066;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    width: 2.5rem;
    text-align: center;
  }
}
</style>
